var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rp-users-tip"},[_c('r-icon',{attrs:{"name":"lock","size":24}}),_c('r-text',[_vm._v(" "+_vm._s(_vm.tip)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }